import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DOWNLOAD_LIST_FEATURE_KEY, DownloadListState } from './download-list.reducer';

export const selectDownloadListState = createFeatureSelector<DownloadListState>(DOWNLOAD_LIST_FEATURE_KEY);

export const selectDownloadList = createSelector(
  selectDownloadListState,
  (state: DownloadListState) => state.downloadList
);

export const selectIsDownloadListActive = createSelector(
  selectDownloadListState,
  (state: DownloadListState) => state.isDownloadListActive
);

export const checkIfInDownloadList = (documentId: number, start_page?: number, end_page?: number) =>
  createSelector(selectDownloadList, (list) =>
    list.some(
      (doc) =>
        doc.documentId === documentId &&
        doc.start_page === start_page &&
        doc.end_page === end_page &&
        doc.type !== 'asset'
    )
  );
